
// Add event listener to filter button
document.querySelector('.blogs-main-wrapper__filter-btn').addEventListener('click', function(){
    if (window.innerWidth < 993){
        this.classList.toggle('blogs-main-wrapper__filter-btn--opened');
        document.querySelector('.blogs-main-wrapper__filter_items').classList.toggle('blogs-main-wrapper__filter_items--opened');
    }
});

// Add event listener to window before reload
window.addEventListener('beforeunload', function() {
  localStorage.setItem('scrollPosition', window.pageYOffset);
});

// Add event listener to window after reload
window.addEventListener('load', function() {
  const scrollPosition = localStorage.getItem('scrollPosition');
  if (scrollPosition) {
    window.scrollTo(0, scrollPosition);
    localStorage.removeItem('scrollPosition');
  }
});
